export default "__VITE_ASSET__C46Le5aS__"